var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg046FireExtinguisher = function Svg046FireExtinguisher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301 120c-57.891 0-105 47.109-105 105v15h210v-15c0-57.891-47.109-105-105-105M196 422h210v90H196zM196 270h210v122H196z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0v30c-90.981 0-165 74.019-165 165v15H62.04L46 452h120l-16.04-242H121v-15c0-74.443 60.557-135 135-135v38.293C270.145 93.25 285.145 90 301 90s30.855 3.25 45 8.293V90h30c33.091 0 60 26.909 60 60h30c0-49.629-40.371-90-90-90h-30V30h120V0z"
  })));
};
export default Svg046FireExtinguisher;